import { render, staticRenderFns } from "./TgSpecialSwiperHor.vue?vue&type=template&id=66c15a65&"
import script from "./TgSpecialSwiperHor.vue?vue&type=script&lang=js&"
export * from "./TgSpecialSwiperHor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports